/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanTaskCommentDto
 */
export interface ExecutionPlanTaskCommentDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskCommentDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskCommentDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskCommentDto
     */
    taskId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskCommentDto
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskCommentDto
     */
    authorUserId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskCommentDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the ExecutionPlanTaskCommentDto interface.
 */
export function instanceOfExecutionPlanTaskCommentDto(value: object): value is ExecutionPlanTaskCommentDto {
    return true;
}

export function ExecutionPlanTaskCommentDtoFromJSON(json: any): ExecutionPlanTaskCommentDto {
    return ExecutionPlanTaskCommentDtoFromJSONTyped(json, false);
}

export function ExecutionPlanTaskCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanTaskCommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'body': json['body'] == null ? undefined : json['body'],
        'authorUserId': json['authorUserId'] == null ? undefined : json['authorUserId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function ExecutionPlanTaskCommentDtoToJSON(json: any): ExecutionPlanTaskCommentDto {
    return ExecutionPlanTaskCommentDtoToJSONTyped(json, false);
}

export function ExecutionPlanTaskCommentDtoToJSONTyped(value?: ExecutionPlanTaskCommentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'planId': value['planId'],
        'taskId': value['taskId'],
        'body': value['body'],
        'authorUserId': value['authorUserId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

